import store from 'store2'

import post from '../../../lib/post'

export default function(o,done){

  var ombStore = store.namespace('omb')

  post(
    'data',
    {
      type: 'all',
      token: ombStore('token'),
    },
    function(error,result){
      if(error){
        done(error)
      } else {
        o.data = result.data
        if(done){
          done()
        }
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/refreshData.js